import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import { memo } from "react";
export const TranscriptLoadingSkeleton = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs("div", {
        "data-testid": "TRANSCRIPT_LOADER",
        className: "flex grow flex-col gap-5 p-8",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4 flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "size-5",
                                variant: "round"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-1/2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-1/3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4 flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "size-5",
                                variant: "round"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-1/2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-full"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                className: "h-4 w-1/3"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
TranscriptLoadingSkeleton.displayName = "TranscriptLoadingSkeleton";
